import { atom, useAtom } from 'jotai';
import { useCallback } from 'react';

import { PBMProgram, PBMSalePrice } from '@/types';

export type ProgramBenefit = {
  price: number;
  flag: boolean;
  salePriceId: number;
  cpf: string;
  quantity: number;
  program?: PBMProgram;
  promotion?: PBMSalePrice;
};

// Map of productId to ProgramBenefit
const programBenefitsAtom = atom<Record<string, ProgramBenefit>>({});

export function useProgramBenefits() {
  const [programBenefits, setProgramBenefits] = useAtom(programBenefitsAtom);

  const setBenefit = useCallback(
    (productId: string, benefit: ProgramBenefit) => {
      setProgramBenefits((prev) => ({ ...prev, [productId]: benefit }));
    },
    [setProgramBenefits],
  );

  const clearBenefit = useCallback(
    (productId: string) => {
      setProgramBenefits((prev) => {
        const { [productId]: _, ...rest } = prev;
        return rest;
      });
    },
    [setProgramBenefits],
  );

  return {
    programBenefits,
    setBenefit,
    clearBenefit,
  };
} 